import React from "react";
import { Grid, Stack, Box, Typography, Link } from "@mui/material";
import puravankaraLogo from "../../assets/icons/footer-logo.svg";
import { useSelector } from "react-redux";
import { COMPARE_VALUE } from "../../config/constant";

function Footer() {
  const { enquiryDetails } = useSelector((state) => state.customerForm);

  const getBrandDetails = () => {
    if (
      enquiryDetails?.data &&
      enquiryDetails?.data?.projectBrandName === COMPARE_VALUE?.Puravankara
    ) {
      return {
        image: null, 
        name: "PURAVANKARA LIMITED",
        address: "130/1 & 130/2, Ulsoor Road, Bengaluru - 560 042, Karnataka",
        phone: "+91 80 4455 5576",
        email: "privilege@puravankara.com",
        website: "www.puravankara.com",
      };
    } else if (
      enquiryDetails?.data &&
      enquiryDetails?.data?.projectBrandName === COMPARE_VALUE?.Provident
    ) {
      return {
        image: null, 
        name: "PROVIDENT HOUSING LIMITED",
        address: "130/1 & 130/2, Ulsoor Road, Bengaluru - 560 042, Karnataka",
        phone: "+91 80 4455 5538",
        email: "premier@providenthousing.com",
        website: "www.providenthousing.com",
      };
    } else if (
      enquiryDetails?.data &&
      enquiryDetails?.data?.projectBrandName === COMPARE_VALUE?.PurvaLand
    ) {
      return {
        image: null, 
        name: "PURAVANKARA LIMITED",
        address: "130/1 & 130/2, Ulsoor Road, Bengaluru - 560 042, Karnataka",
        phone: "+91 80 4455 5576",
        email: "privilege@puravankara.com",
        website: "www.puravankara.com",
      };
    }
    return {
      image: null, 
      name: "PURAVANKARA LIMITED",
      address: "130/1 & 130/2, Ulsoor Road, Bengaluru - 560 042, Karnataka",
      phone: "+91 80 4455 5576",
      email: "privilege@puravankara.com",
      website: "www.puravankara.com",
    };
  };

  const { image, name, address, phone, email, website } = getBrandDetails()
  
  return (
    <Stack
      sx={{
        backgroundColor: "#1A407D",
        width: "100%",
        color: "#ffff",
        display: "flex",
        justifyContent: "center",
        paddingTop: "37.5px",
        paddingBottom: "37.5px",
      }}
    >
      <Grid
        container
        spacing={0}
        className="headerPLeftRight"
        sx={{
          p: 0,
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          flexDirection: "column",
          paddingLeft: {
            xs: "16px",
            sm: "16px",
            md: "7%",
          },
          paddingRight: {
            xs: "16px",
            sm: "16px",
            md: "7%",
          },
        }}
      > 
        <Typography sx={{ color: "#fff", textAlign: "center", fontSize: '28px', fontWeight: 600, mb: 2 }}>
          {name}
        </Typography>
        
        <Box sx={{textAlign: 'center', fontSize: '16px', fontWeight: '400'}}>
          <Typography>
            {address}
          </Typography>
          <Typography>
            Tel: {phone} • Email: {email} • Website:{" "}
            <Link href={`https://${website}`} target="_blank" underline="always" sx={{color: '#fff', textDecorationColor: "#fff"}}>{website}</Link>
          </Typography>
        </Box>
      </Grid>
    </Stack>
  );
}

export default Footer;